import React, { Fragment, useState } from "react";
import PublicHeader from "./PublicHeader";
import PublicNavHader from "./PublicNavHader";

const PublicNav = ({ title, onClick: ClickToAddEvent, onClick2, onClick3 }) => {
  const [toggle, setToggle] = useState("");
  const onClick = (name) => setToggle(toggle === name ? "" : name);
  return (
    <Fragment>
      <PublicNavHader />
      <PublicHeader
        onNote={() => onClick("chatbox")}
        onNotification={() => onClick("notification")}
        onProfile={() => onClick("profile")}
        toggle={toggle}
        title={title}
        onBox={() => onClick("box")}
        onClick={() => ClickToAddEvent()}
      />
    </Fragment>
  );
};

export default PublicNav;
